export default {
   NOTE_STATUS_LOADING: 0,
   NOTE_STATUS_READY: 1,
   NOTE_STATUS_LOCKED: 2,
   NOTE_STATUS_EDITING: 3
}
